export const INITIAL_PLAN_WEEKLY_SPEND_OPPS = 'initial_plan_weekly_spend_opps';
export const INITIAL_PLAN_MONTHLY_SPEND_OPPS = 'initial_plan_monthly_spend_opps';
export const INITIAL_PLAN_WEEKLY_HEADERS_OPPS = 'initial_plan_column_headers_weekly_opps';
export const INITIAL_PLAN_DOWNLOAD_FILE_WEEKLY_OPPS = 'initial_plan_spend_weekly_opps.xlsx';
export const INITIAL_PLAN_DOWNLOAD_FILE_MONTHLY_OPPS = 'initial_plan_spend_monthly_opps.xlsx';
